import './ModelTable.scss'
export let ModelTable = ({ children, color, style, myId }) => {
  return (
    <div className={`ModelTable__container ${style && `ModelTable__container--${style}`}`}>
      <table id={myId && myId} className={`ModelTable ModelTable--${color} ${style && `ModelTable--${style}`}`}>
        {children}
      </table>
    </div>
  )
} 